module.exports = __webpack_public_path__ + "img/制御工学3_5_3.db83488b.png";